import { render, staticRenderFns } from "./DesktopBlockedView.vue?vue&type=template&id=2af1e5c5&scoped=true"
import script from "./DesktopBlockedView.vue?vue&type=script&lang=js"
export * from "./DesktopBlockedView.vue?vue&type=script&lang=js"
import style0 from "./DesktopBlockedView.vue?vue&type=style&index=0&id=2af1e5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1e5c5",
  null
  
)

export default component.exports